import PropTypes from 'prop-types'

import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { generateUrls } from '@hooks/useBrand'
import useBrandThemes from '@hooks/useBrandThemes'
import useCurrentUser from '@hooks/useCurrentUser'

import EntitySelector from '@components/EntitySelector'

const goToBrand = (brand_id) => {
  const { editBrandRelationsUrl } = generateUrls({ id: brand_id })
  window.location.hash = `${editBrandRelationsUrl}?redirect=${generateRedirectUrl()}`
}

const BrandDetails = (props) => {
  const { agencyFormPayload } = props || {}
  const {
    entityState: {
      brand_id,
      brand_theme_id,
    },
    handlers,
    setEntityState,
  } = agencyFormPayload

  const { filteredBrandThemes } = useBrandThemes({
    filters: { brand_id },
    performHttpRequests: !!brand_id,
  })

  const { isBrandUser } = useCurrentUser()

  const { editBrandUrl } = generateUrls({ id: brand_id })

  return (
    <DashboardModule title="Brand Details">
      <Form padding="large">
        <Form.Row>
          <EntitySelector
            callbacks={{
              goToFunction: () => goToBrand(brand_id),
              selectItem: brand => setEntityState({ brand_id: brand ? brand.id : null, brand_theme_id: null }),
            }}
            disabled={isBrandUser}
            entityKey="brands"
            goToHref={`${editBrandUrl}?redirect=${generateRedirectUrl()}`}
            label="* Brand"
            selectedItemId={brand_id}
          />

          <Form.Field label="Brand Theme" marginTop={['large', 0]}>
            <select
              data-value-type="number"
              disabled={!brand_id}
              name="brand_theme_id"
              value={brand_theme_id}
              {...handlers}
            >
              <option value="">{brand_id ? 'Select Brand Theme' : 'Please Select Brand'}</option>
              {filteredBrandThemes.map(brandTheme => (
                <option key={brandTheme.id} value={brandTheme.id}>
                  {brandTheme.title}
                </option>
              ))}
            </select>
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

BrandDetails.propTypes = {
  agencyFormPayload: PropTypes.shape({
    entityState: PropTypes.shape({
      brand_id: PropTypes.number,
      brand_theme_id: PropTypes.number,
    }),
    setEntityState: PropTypes.func.isRequired,
  }).isRequired,
}

export default BrandDetails
